import { Translator } from '../../types/ApiResponseTypes'
import {
  isLeaderboardResponse,
  leaderboardItem,
  leaderboardItem as leaderboardResponseItem,
} from '@/types/customer/CustomerResponseType'
import { LeaderboardItem } from '@/types/customer/CustomerType'

class LeaderboardResponseTranslator implements Translator<leaderboardItem[]> {
  convert(response: any): leaderboardItem[] | [] {
    if (isLeaderboardResponse(response)) {
      return this.convertToLeaderBoardModel(response)
    }
    return []
  }

  convertToLeaderBoardModel(response: leaderboardResponseItem[]): LeaderboardItem[] {
    return response.map((item) => ({
      id: item.id,
      msisdn: item.msisdn,
      firstName: item.firstName,
      lastName: item.lastName,
      label: item.label,
      volume: item.volume,
      cost: item.cost,
    }))
  }
}
export default new LeaderboardResponseTranslator()
